// extracted by mini-css-extract-plugin
export var pillWrapper = "_y5-0";
export var showOverflow = "_y5-1";